import React, { useContext, useEffect } from 'react';
import {
  Box, Button, Container, TextField,
} from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import AlertContext from '../../../../Context/AlertContext';
import Elements from '../../../Elements';
import ROUTES from '../../../../Configs/routes';

export default function Component({
  classes, error, message,
}) {
  const navigate = useNavigate();

  const { openAlert } = useContext(AlertContext);

  useEffect(() => {
    if (error) {
      openAlert({
        message: `Something went wrong. ${message}`,
        severity: 'error',
      });
    }
  }, [error]);

  return (
    <Elements.PageBase navigate={navigate} noNav>
      <Box className={classes.root}>
        <Elements.Navigator title="Withdraw" />
        <Container sx={{ py: 3 }}>
          <Box fontWeight="600" mb={1}>Withdraw amount</Box>
          <TextField
            size="small"
            InputProps={{
              startAdornment: '₣',
            }}
            fullWidth
            placeholder="0"
          />
          <Box display="flex" justifyContent="space-between" mt={0.5}>
            <Box className="mute s-10">Your OenoWallet balance</Box>
            <Box className="weight-600 s-12">₣ 240.85</Box>
          </Box>

          <Box fontWeight="600" mb={1} mt={2}>Withdraw amount</Box>
          <Box border="1px solid #E5E5E5" py={1} px={1.5} borderRadius="10px">
            <Box className="weight-700">American Express</Box>
            <Box mt={0.5} className="s-12">1234567889</Box>
          </Box>
          <Box textAlign="right" mt={0.5}>
            <Box component={Link} to="/" color="#2391D9" fontSize={10} className="link">Change withdraw bank account</Box>
          </Box>
        </Container>
        <Container className="floating-action">
          <Button fullWidth variant="contained" className="btn-contained" onClick={() => navigate(`${ROUTES.wallet()}/pin`)}>Withdraw</Button>
        </Container>
      </Box>
    </Elements.PageBase>
  );
}
